import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useNavigate } from '@rocketlane/rocket-router';
import { useBoolean } from 'ahooks';
import { useCallback, useMemo } from 'react';
import { AccountStatus } from 'api/account';
import { PermissionSetType } from 'api/models';
import { SubscriptionRenewalFailedBanner, TrialExpiryBanner } from 'components/molecules/account-expiry-banner';
import { getPlanName } from 'components/organisms/module-settings/billing/utils';
import { RoutePaths } from 'constant';
import { useUserPermissionSetType } from 'hooks/permissions';
import { useAccount, useBillingFeatureFlag, useIsAccountActive, useIsAccountActiveWithoutBilling } from 'hooks/use-account';
import { useAccountDataQuery } from 'queries/account';
import { getDevEnv } from 'utils/is-localhost';
import { SubscriptionExpired, TrialExpired } from './account-expired-pages';
import { BuyPage } from './buy';
import { RhModal } from './revenuehero-demo';
export const AccountAssessment = ({ children })=>{
    const history = useNavigate();
    const { expiryDate, status } = useAccount();
    const { data: accountData } = useAccountDataQuery();
    const isAccActive = useIsAccountActive();
    const { isLocal } = getDevEnv();
    const isAccActiveWithoutBilling = useIsAccountActiveWithoutBilling();
    const isPageInIframe = useMemo(()=>window !== window.top, []);
    const currentUserPermissionSetType = useUserPermissionSetType();
    const isAccountAdmin = useMemo(()=>currentUserPermissionSetType === PermissionSetType.AccountAdmin, [
        currentUserPermissionSetType
    ]);
    const isTrialExpired = useMemo(()=>!isAccActiveWithoutBilling && status === AccountStatus.Trial, [
        status,
        isAccActiveWithoutBilling
    ]);
    const currentPlan = useMemo(()=>{
        var _accountData_billingMeta;
        return (accountData === null || accountData === void 0 ? void 0 : (_accountData_billingMeta = accountData.billingMeta) === null || _accountData_billingMeta === void 0 ? void 0 : _accountData_billingMeta.subscription) ? getPlanName(accountData.billingMeta.subscription.plan.planName) : null;
    }, [
        accountData
    ]);
    const [canShowForm, { setTrue: showForm, setFalse: closeForm }] = useBoolean(false);
    const [isRhVisible, { setTrue: showRhModal, setFalse: closeRhModal }] = useBoolean(false);
    const isBillingEnabled = useBillingFeatureFlag();
    const onBuy = useCallback(()=>{
        if (isBillingEnabled && isAccountAdmin) {
            history(RoutePaths.billingSettings);
        } else {
            showForm();
        }
    }, [
        history,
        isAccountAdmin,
        isBillingEnabled,
        showForm
    ]);
    if (expiryDate == null) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    if (isPageInIframe) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(RhModal, {
                visible: isRhVisible,
                close: closeRhModal
            }),
            !isLocal ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(TrialExpiryBanner, {
                        onBuy: onBuy,
                        onBookDemo: showRhModal
                    }),
                    /*#__PURE__*/ _jsx(SubscriptionRenewalFailedBanner, {})
                ]
            }) : null,
            !isBillingEnabled ? canShowForm || isTrialExpired ? /*#__PURE__*/ _jsx(BuyPage, {
                isExpired: isTrialExpired,
                handleClose: closeForm
            }) : children : isAccActive || isAccountAdmin ? children : isTrialExpired ? /*#__PURE__*/ _jsx(TrialExpired, {
                currentPlan: currentPlan
            }) : /*#__PURE__*/ _jsx(SubscriptionExpired, {})
        ]
    });
};
